import Meta from '@/components/common/Meta'

import DormRoomMoversCollegeMovingStoragePage from '@/v2/components/pages/landing-pages/dorm-room-movers-college-moving-storage-page'
import {
  faqSectionContent,
  metaImages,
  ogImages
} from '@/v2/constants/pages/landing-pages/dorm-room-movers-college-moving-storage-page'
import { LANDING_PAGES_META_CONTENTS } from '@/v2/constants/pages/landing-pages/meta/landing-pages-meta-content'

interface DormRoomMoversCollegeMovingStoragePageProps {}

const Page: React.FC<DormRoomMoversCollegeMovingStoragePageProps> = () => {
  return (
    <>
      <Meta
        title={
          LANDING_PAGES_META_CONTENTS.dorm_room_movers_college_moving_storage.title ??
          LANDING_PAGES_META_CONTENTS.default?.title ??
          ''
        }
        keywords={
          LANDING_PAGES_META_CONTENTS.dorm_room_movers_college_moving_storage?.keywords ??
          LANDING_PAGES_META_CONTENTS.default?.keywords ??
          ''
        }
        description={
          LANDING_PAGES_META_CONTENTS.dorm_room_movers_college_moving_storage?.description ??
          LANDING_PAGES_META_CONTENTS.default?.description ??
          ''
        }
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
        additionalData={{
          faq: faqSectionContent.questions
        }}
      />

      <DormRoomMoversCollegeMovingStoragePage />
    </>
  )
}

export default Page
